import { Link, useParams } from 'react-router';

export default function LangLink({ to, ...props }) {
    const { lang } = useParams();
    const path = to.startsWith('/') ? `/${lang}${to}` : `/${lang}/${to}`;
    return <Link to={path} {...props} />;
}
